import { BLOG_PROSE_CLASSES } from "@/lib/blog-prose";

interface BlogMarkdownContentProps {
  html: string;
}

/** HTML ya saneado en servidor (renderBlogMarkdown) — ver src/lib/markdown-render.server.ts. */
export function BlogMarkdownContent({ html }: BlogMarkdownContentProps) {
  return <div className={BLOG_PROSE_CLASSES} dangerouslySetInnerHTML={{ __html: html }} />;
}
